import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  loadTestData
} from '../../actions/client';
import {
  NF_TEST,
  LA_TEST,
  RR_TEST,
  BS_TEST,
  LF_TEST,
} from '../../constants.js';
import Welcome from './Welcome';
import Tests from './Tests';
import LossAversion from './LossAversion';
import RetirementRegret from './RetirementRegret';
import NarrowFraming from './NarrowFraming';
import BehavorialStressQuestion from './BehavioralStress';
import LossFrequency from './LossFrequency';
import s from './ClientMode.css';

class ClientMode extends PureComponent {

  componentWillMount() {
    this.props.loadTestData();
  }

  render() {
    const { testData, activeTest } = this.props;
    const showWelcome = testData.gender && testData.birthYear ? false : true;
    const showTests = activeTest ? false : true;
    if(testData.id) {
      return (
        <div className={s.bhvfin} style={{marginBottom:'60px'}}>
          <div className="row">
            <div className="col-md-12">
              <div className={s.headerTitle}>WISDOMTREE BEHAVIORAL FINANCE</div>
            </div>
          </div>
          {showWelcome &&
            <Welcome />
          }
          {!showWelcome && (activeTest === '' || activeTest === 'begin' || activeTest === 'end') &&
            <Tests />
          }
          { activeTest === LA_TEST &&
            <LossAversion />
          }
          { activeTest === RR_TEST &&
            <RetirementRegret />
          }
          { activeTest === NF_TEST &&
            <NarrowFraming />
          }
          { activeTest === BS_TEST &&
            <BehavorialStressQuestion />
          }
          { activeTest === LF_TEST &&
            <LossFrequency />
          }
        </div>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    testData: state.clientData.testData,
    activeTest: state.clientData.activeTest,
  };
}

export default connect(mapStateToProps, {
  loadTestData,
})(ClientMode);



// WEBPACK FOOTER //
// ./src/components/ClientMode/ClientMode.js